import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import DoneGroup from './components/DoneGroup';
import CircleExpand from './components/CircleExpand';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import Header from './components/Header'; 
import Process from './components/Process';
import Testimonials from './components/Testimonials';
import FixedBackgroundSection from './components/FixedBackgroundSection';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';

function App() {
  const [scrollY, setScrollY] = useState(0);
  const [currentPage, setCurrentPage] = useState('home');

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Handle hash-based navigation
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      if (hash === '#privacy-policy') {
        setCurrentPage('privacy');
        window.scrollTo(0, 0);
      } else if (hash === '#terms-conditions') {
        setCurrentPage('terms');
        window.scrollTo(0, 0);
      } else {
        setCurrentPage('home');
      }
    };

    // Check initial hash
    handleHashChange();

    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  const goHome = () => {
    window.location.hash = '';
    setCurrentPage('home');
    window.scrollTo(0, 0);
  };

  const pageVariants = {
    initial: { opacity: 0 },
    in: { opacity: 1 },
    out: { opacity: 0 }
  };

  const pageTransition = {
    type: "tween",
    ease: "anticipate",
    duration: 0.6
  };

  if (currentPage === 'privacy') {
    return <PrivacyPolicy onGoHome={goHome} />;
  }

  if (currentPage === 'terms') {
    return <TermsConditions onGoHome={goHome} />;
  }

  return (
    <motion.div 
      className="min-h-screen bg-white"
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
    >
      <Header />
      <Hero scrollY={scrollY} />
      <About />
      <Services />
      <CircleExpand />
      <Process />
      <FixedBackgroundSection />
      <Testimonials />
      <DoneGroup /> {/* Now positioned last before Contact */}
      <ContactForm />
      <Footer />
    </motion.div>
  );
}

export default App;
